module.exports = __webpack_public_path__ + "static/img/n-log.f3f36066.png";